import { Stack } from '@mantine/core';
import { Button, Title } from '@repo/foundations';
import { uuidv4 } from 'lib0/random';
import { useState } from 'react';
import InspectSQLBlock from './../InspectIntegrationPage/InspectSQLBlock';

interface SQLBlockWrapperProps {
	onDelete: () => void;
}

function SQLBlockWrapper({ onDelete }: SQLBlockWrapperProps) {
	return <InspectSQLBlock onDelete={onDelete} />;
}

function QueryDatabasePage() {
	const [blocks, setBlocks] = useState<string[]>(() => [uuidv4()]);

	return (
		<Stack>
			<Title order={3}>
				Run queries on a read-only replica of the secoda database
			</Title>
			{blocks.map((block) => (
				<SQLBlockWrapper
					key={block}
					onDelete={() => setBlocks(blocks.filter((b) => b !== block))}
				/>
			))}
			<Button
				size="md"
				variant="primary"
				onClick={() => setBlocks([...blocks, uuidv4()])}
			>
				New block
			</Button>
		</Stack>
	);
}

export default QueryDatabasePage;
